import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';

export type useToggleRestrictionsPropsType = {
  restrictionsFieldName: string;
  toggleFieldName: string;
};

export function useToggleRestrictions({
  restrictionsFieldName,
  toggleFieldName,
}: useToggleRestrictionsPropsType): boolean {
  const { setValue } = useFormContext();
  const { [toggleFieldName]: restrictionsEnabled } = useWatch({
    name: [toggleFieldName],
  });

  useEffect(() => {
    if (!restrictionsEnabled) {
      setValue(restrictionsFieldName, {});
    }
  }, [restrictionsEnabled, restrictionsFieldName, setValue]);

  return restrictionsEnabled;
}
